import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { standardCommand } from '../../../core/model/command';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { MoveToCompanyCommandHandler } from './move-to-company-command-handler.service';
import { propertyCommand } from '../../command/property.command';
import { PropertyTaxRentalCommandHandler } from './property-tax-rental-command-handler.service';

@Injectable()
export class PropertyFormCommandHandler extends CommandHandlerResolver {
  constructor(
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    moveToCompanyHandler: MoveToCompanyCommandHandler,
    propertyTaxRentalHandler: PropertyTaxRentalCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(propertyCommand.moveToCompany, moveToCompanyHandler);
    this.addHandler(propertyCommand.propertyTaxRental, propertyTaxRentalHandler);
  }
}
